
import { Union, Record } from "../../../fable_modules/fable-library-js.5.0.0-rc.2/Types.js";
import { CustomerConfiguration_$reflection, ClientApiResponse$1_$reflection, AppLogoVariant_$reflection, FormState_$reflection, RequestedValue$1_$reflection, AppLogoConfiguration_$reflection } from "../../../Shared/Shared.js";
import { union_type, string_type, class_type, record_type } from "../../../fable_modules/fable-library-js.5.0.0-rc.2/Reflection.js";

export class State extends Record {
    constructor(AppLogoConfiguration, FormState) {
        super();
        this.AppLogoConfiguration = AppLogoConfiguration;
        this.FormState = FormState;
    }
}

export function State_$reflection() {
    return record_type("Settings.Logo.Types.State", [], State, () => [["AppLogoConfiguration", RequestedValue$1_$reflection(AppLogoConfiguration_$reflection())], ["FormState", FormState_$reflection()]]);
}

export class Msg extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["UploadLogo", "DeleteLogo", "LogoSaved", "LogoDeleted", "CustomerConfigurationFetched", "FetchError"];
    }
}

export function Msg_$reflection() {
    return union_type("Settings.Logo.Types.Msg", [], Msg, () => [[["Item1", AppLogoVariant_$reflection()], ["Item2", class_type("Browser.Types.File", undefined)]], [["Item", AppLogoVariant_$reflection()]], [["Item", ClientApiResponse$1_$reflection(string_type)]], [["Item", ClientApiResponse$1_$reflection(string_type)]], [["Item", CustomerConfiguration_$reflection()]], [["Item", class_type("System.Exception")]]]);
}

